export const getSectionName = (
	item: { isInTrash: boolean, isArchived: boolean }
): 'DRIVE' | 'TRASH' | 'ARCHIVE' => {
	if (!item) return 'DRIVE';
	return item.isInTrash
		? 'TRASH'
		: item.isArchived
			? 'ARCHIVE'
			: 'DRIVE';
}
